export const monthNamesShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

export const weekdayNamesShort = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat'
]

export const DEFAULT_LABELS = {
  open: 'Open calendar',
  next: 'Next month',
  previous: 'Previous month',
  nextYear: 'Next year',
  previousYear: 'Previous year'
}
